module.exports = __webpack_public_path__ + "static/media/inovator_muda_id_logo.d3128adf.png";